import { forwardRef } from "@chakra-ui/react"
import { Searchbox } from "components/Searchbox"
import {
  AP_SUBJECTS,
  ACTIVITIES,
  IB_SUBJECTS,
  LANGUAGES,
  RELIGIONS,
  SPORTS,
  COUNTIES,
} from "data/dataSets"
import { CustomSearchTypes, TextInputProps, Option } from "types"
import { HighSchoolSearch } from "components/HighSchoolSearch"
import { CollegeSearch } from "components/CollegeSearch"
import { optionize } from "data/utils"

interface SearchHandlerProps extends Omit<TextInputProps, "onChange"> {
  onChange: (value: any) => void
}

/** A combobox component built on React Select
 * - Use for options that *are not* commonly filled with autocomplete. e.g. high schools, religions, etc.
 */
export const SearchHandler = forwardRef<SearchHandlerProps, "div">(
  (props, ref) => {
    const { name, ...rest } = props

    let searchOptions: Option[] = []

    switch (props.type as CustomSearchTypes) {
      case "highSchoolSearch":
        return <HighSchoolSearch ref={ref} {...props} />
      case "collegeSearch":
        return <CollegeSearch ref={ref} {...props} />
      case "countySearch":
        searchOptions = optionize(COUNTIES)
        break
      case "sportSearch":
        searchOptions = optionize(SPORTS)
        break
      case "activitySearch":
        searchOptions = optionize(ACTIVITIES)
        break
      case "apSearch":
        searchOptions = optionize(AP_SUBJECTS)
        break
      case "ibSearch":
        searchOptions = optionize(IB_SUBJECTS)
        break
      case "languageSearch":
        searchOptions = optionize(LANGUAGES)
        break
      case "religionSearch":
        searchOptions = optionize(RELIGIONS)
        break
      default:
        // @ts-ignore
        searchOptions = rest.options
    }


    // This is the synchronous search for when options are known on load
    return (
      <Searchbox
        ref={ref}
        name={props.name}
        options={[
          ...searchOptions,
          { label: "Not Found", value: "Not Found" },
        ]}
        isAsync={false}
        {...rest}
      />
    )
  },
)
